import { call, put, takeLatest } from 'redux-saga/effects';

import { CompanyUser } from '@models/User';
import { UserApi } from '@apis/UserApi';
import { SagaPayload } from '@utils/typescript';
import { UserOtpCodeApi } from '@apis/UserOtpCodeApi';

import {
  companyUsersFetch,
  frontlineUsersFetch,
  otpCodeRequest,
  OtpCodeRequestPayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handleCompanyUsersFetch() {
  const state: StateUpdatePayload = { companyUsers: [] };
  try {
    state.companyUsers = (yield call(UserApi.getAllCompanyUsers)) as CompanyUser[];
    yield put(stateUpdate(state));
  } catch { }
}

function* handleFrontlineUsersFetch() {
  const state: StateUpdatePayload = { frontlineUsers: [] };
  try {
    state.frontlineUsers = (yield call(UserApi.getAllFrontlineUsers)) as CompanyUser[];
    yield put(stateUpdate(state));
  } catch { }
}

function* handleOtpCodeRequest({ payload }: SagaPayload<OtpCodeRequestPayload>) {
  yield call(UserOtpCodeApi.create, payload);
}

export default function* () {
  yield takeLatest(companyUsersFetch, handleCompanyUsersFetch);
  yield takeLatest(frontlineUsersFetch, handleFrontlineUsersFetch);
  yield takeLatest(otpCodeRequest, handleOtpCodeRequest);
}
